// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");

var regexSpecialRe = /[.*+?^${}()|[\\]\\\\]/g;

function escapeRegex(text) {
  return text.replace(regexSpecialRe, "\\$&");
}

function wildcardToRegex(text) {
  return Belt_Array.map(Js_string.split(text, ""), (function ($$char) {
                  switch ($$char) {
                    case "*" :
                        return ".*";
                    case "?" :
                        return ".";
                    default:
                      return $$char.replace(regexSpecialRe, "\\$&");
                  }
                })).join("");
}

function simpleMatchTypeToString(matchType) {
  switch (matchType) {
    case "Contains" :
        return "contains";
    case "StartsWith" :
        return "starts_with";
    case "EndsWith" :
        return "ends_with";
    case "Exact" :
        return "exact";
    case "Wildcard" :
        return "wildcard";
    
  }
}

function simpleMatchTypeFromString(value) {
  switch (value) {
    case "ends_with" :
        return "EndsWith";
    case "exact" :
        return "Exact";
    case "starts_with" :
        return "StartsWith";
    case "wildcard" :
        return "Wildcard";
    default:
      return "Contains";
  }
}

function simpleMatchTypeLabel(matchType) {
  switch (matchType) {
    case "Contains" :
        return "Contains text";
    case "StartsWith" :
        return "Starts with";
    case "EndsWith" :
        return "Ends with";
    case "Exact" :
        return "Exact match";
    case "Wildcard" :
        return "Wildcard (* and ?)";
    
  }
}

function compileSimpleCondition(matchType, text) {
  var trimmed = text.trim();
  if (trimmed === "") {
    return ;
  }
  switch (matchType) {
    case "Contains" :
        return {
                TAG: "NativeOp",
                _0: "contains",
                _1: trimmed
              };
    case "StartsWith" :
        return {
                TAG: "NativeOp",
                _0: "starts_with",
                _1: trimmed
              };
    case "EndsWith" :
        return {
                TAG: "NativeOp",
                _0: "ends_with",
                _1: trimmed
              };
    case "Exact" :
        return {
                TAG: "NativeOp",
                _0: "eq",
                _1: trimmed
              };
    case "Wildcard" :
        return {
                TAG: "RegexPattern",
                _0: "^" + wildcardToRegex(trimmed) + "$"
              };
    
  }
}

function compileSimpleRegexPattern(matchType, text) {
  var trimmed = text.trim();
  if (trimmed === "") {
    return ;
  }
  switch (matchType) {
    case "Contains" :
        return trimmed.replace(regexSpecialRe, "\\$&");
    case "StartsWith" :
        return "^" + trimmed.replace(regexSpecialRe, "\\$&");
    case "EndsWith" :
        return trimmed.replace(regexSpecialRe, "\\$&") + "$";
    case "Exact" :
        return "^" + trimmed.replace(regexSpecialRe, "\\$&") + "$";
    case "Wildcard" :
        return "^" + wildcardToRegex(trimmed) + "$";
    
  }
}

function simpleMatchTypeLabelForCapture(matchType) {
  switch (matchType) {
    case "Contains" :
        return "Text after";
    case "StartsWith" :
        return "Prefix to skip";
    case "EndsWith" :
        return "Text before";
    case "Exact" :
        return "Exact match";
    case "Wildcard" :
        return "Wildcard (* and ?)";
    
  }
}

function compileCapturePattern(matchType, text, group) {
  var trimmed = text.trim();
  if (trimmed === "") {
    return ;
  }
  var escaped = trimmed.replace(regexSpecialRe, "\\$&");
  switch (matchType) {
    case "Contains" :
        return escaped + "(.+)";
    case "StartsWith" :
        return "^" + escaped + "(.+)";
    case "EndsWith" :
        return "(.+)" + escaped + "$";
    case "Exact" :
        return "^(" + escaped + ")$";
    case "Wildcard" :
        var body = wildcardToRegex(trimmed);
        if (group <= 0) {
          return "^(" + body + ")$";
        } else {
          return "^" + body + "$";
        }
    
  }
}

exports.regexSpecialRe = regexSpecialRe;
exports.escapeRegex = escapeRegex;
exports.wildcardToRegex = wildcardToRegex;
exports.simpleMatchTypeToString = simpleMatchTypeToString;
exports.simpleMatchTypeFromString = simpleMatchTypeFromString;
exports.simpleMatchTypeLabel = simpleMatchTypeLabel;
exports.compileSimpleCondition = compileSimpleCondition;
exports.compileSimpleRegexPattern = compileSimpleRegexPattern;
exports.simpleMatchTypeLabelForCapture = simpleMatchTypeLabelForCapture;
exports.compileCapturePattern = compileCapturePattern;
/* No side effect */
